/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import { Context } from 'context/AuthContext';
import { GET_LIST_AVISO } from 'services/Aviso';
import { COUNT_PENDENCIA_USUARIO_ATUAL } from 'services/Pendencia';
import { COUNT_RASCUNHO_USUARIO_ATUAL } from 'services/Rascunho';

import rascunho from 'assets/imgs/icons/rascunho.png';
import pendencias from 'assets/imgs/icons/pendencias.png';
import onoff from 'assets/imgs/icons/plano_midias_on_off.png';
// import atendimento from 'assets/imgs/icons/atendimento_ao_usuario.png';
import consultar from 'assets/imgs/icons/consultar.png';
import materiais from 'assets/imgs/icons/icon_materiais.svg';
// import histsolicitacoes from 'assets/imgs/icons/icon_histsolicitacoes.svg';
import relatorios from 'assets/imgs/icons/relatorios.png';

import { GET_SITE_CONFIG } from 'services/SysConfig';
import './styles.scss';

const ContentHome = () => {
  const [warnings, setWarnings] = useState([]);
  const { showLoader } = useContext(Context);
  const [corPendencia, setCorPendencia] = useState([]);
  const [corRascunho, setCorRascunho] = useState([]);
  const [mensagem, setMensagem] = useState('');

  async function getHomeMessage() {
    const data = await GET_SITE_CONFIG({ keyFilter: 'MENSAGEM_HOME' });
    if (data.value != null && data.value.length > 0) {
      return data.value[0].value;
    }

    return '';
  }

  useEffect(() => {
    async function fetchData() {
      showLoader(true);

      const msg = await getHomeMessage();
      setMensagem(msg);

      const corPendenciaResult = await COUNT_PENDENCIA_USUARIO_ATUAL();
      setCorPendencia(corPendenciaResult.value);

      const countUsuarioAtual = await COUNT_RASCUNHO_USUARIO_ATUAL();
      setCorRascunho(countUsuarioAtual.value);

      const warningsResult = await GET_LIST_AVISO();
      setWarnings(warningsResult.value);

      showLoader(false);
    }
    fetchData();
  }, []);

  return (
    <>
      <div className="wrapper-choose-the-costumer">
        <div className="warnings">
          <Carousel>
            {warnings?.map((item) => {
              return (
                <Carousel.Item key={item.avisoId}>
                  {item.urlRedirecionamento ? (
                    <a
                      href={item.urlRedirecionamento}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={item.urlImagem}
                        alt={item.texto}
                      />
                    </a>
                  ) : (
                    <img
                      className="d-block w-100"
                      src={item.urlImagem}
                      alt={item.texto}
                    />
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
        {/* <div className="actions"> */}
        <div className="actions">
          <div>
            <Link to="/pedido-materiais">
              <div>
                <div className="button-content">
                  <div>
                    <img src={materiais} alt="pedido-materiais" />
                  </div>
                  <div className="btn-divider" />
                  <div>Artes Personalizadas</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Solicite artes personalizadas com qualquer layout, produto
                    ou dimensões necessárias
                  </p>
                </div>
              </div>
            </Link>

            <Link to="/rascunho">
              <div style={{ backgroundColor: corRascunho > 0 ? 'red' : '' }}>
                <div className="button-content">
                  <div>
                    <img src={rascunho} alt="Rascunhos" />
                  </div>
                  <div className="btn-divider" style={{ marginLeft: '10px' }} />
                  <div>Rascunhos</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Lista de rascunhos (solicitações com preenchimento iniciado
                    mas não finalizada)
                  </p>
                </div>
              </div>
            </Link>
          </div>

          <div>
            <Link to="/pendencias">
              <div style={{ backgroundColor: corPendencia > 0 ? 'red' : '' }}>
                <div className="button-content">
                  <div>
                    <img src={pendencias} alt="pendencias" />
                  </div>
                  <div className="btn-divider" />
                  <div>Pendências</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    PÁGINA PARA VISUALIZAÇÃO DAS SUAS PENDÊNCIAS E APROVAÇÃO DE
                    ARTES
                  </p>
                </div>
              </div>
            </Link>

            <Link
              to={{
                pathname:
                  'https://camilalimentos-my.sharepoint.com/my?id=%2Fpersonal%2Fbruna%5Fmenino%5Fcamil%5Fcom%5Fbr%2FDocuments%2FTABLOIDES%20E%20KIT%20DIGITAL%2F2025&ga=1',
              }}
              target="_blank"
            >
              <div>
                <div className="button-content">
                  <div>
                    <img src={relatorios} alt="Calendário promocional" />
                  </div>
                  <div className="btn-divider" />
                  <div>
                    CALENDÁRIO <br /> PROMOCIONAL
                  </div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Artes Sazonais – acesse artes sazonais prontas para
                    adaptação nos clientes
                  </p>
                </div>
              </div>
            </Link>
          </div>

          <div>
            <Link to="/consulta">
              <div>
                <div className="button-content">
                  <div>
                    <img src={consultar} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>
                    SOLICITAÇÕES <br /> EM ANDAMENTO
                  </div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Página de consulta para visualizar suas solicitações em
                    andamento e seus status
                  </p>
                </div>
              </div>
            </Link>

            <Link to="/banco-de-artes">
              <div>
                <div className="button-content">
                  <div>
                    <img src={onoff} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>Banco de artes</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    BANCO DAS ARTES JÁ FEITAS NA PLATAFORMA PARA CONSULTA E PARA
                    SOLICITAR NOVAMENTE
                  </p>
                </div>
              </div>
            </Link>
          </div>
          <div />
          <div className="d-flex justify-content-center text-center">
            <h5 className="font-weight-bold home-horario-atendimento p-5">
              {mensagem}
            </h5>
          </div>
        </div>
      </div>
    </>
  );
};

const App = () => {
  return (
    <>
      <HeaderApp />
      <ContentHome />
      <Bottom />
    </>
  );
};

export default App;
